import lang from '@/lang'
export const CATEGORY_TYPE = {
  ARTICLE: 'ARTICLE',
  FILE: 'FILE'
}

export const FILE_TYPE = {
  PDF: 'PDF',
  QCOW: 'QCOW',
  ISO: 'ISO'
}

export const SOFTEWARE_TYPE = {
  PACKAGE: {
    CODE: 'PACKAGE',
    TXT: lang.t('software.package')
  },
  SOFT: {
    CODE: 'SOFT',
    TXT: lang.t('software.soft')
  }
}

export const MATCH_TYPE = {
  LIKE: 'LIKE', // 模糊匹配
  MATCH: 'MATCH' // 全名称匹配
}

export const CONTACT_URL = {
  FEEDBACK_URL: 'https://support.qq.com/products/351669',
  ONLINE_CONTACT_URL: 'https://ocs.ruijie.com.cn/?p=rcd',
  BAO_URL: 'https://www.ruijie.com.cn/fw/bx/',
  XIU_URL: 'https://www.ruijie.com.cn/fw/wxzhx/'
}

export const PERMISSIONS = {
  SOFTWARE_MANAGER: 'SOFTWARE_MANAGER'
}

export const SOFT_STOP_TYPE = {
  SOFT: 'soft',
  PACKAGE: 'package'
}

export const NET_TYPE = {
  WIRED: {
    CODE: 'WIRED',
    TXT: lang.t('enums.netType.WIRED')
  },
  WIRELESS: {
    CODE: 'WIRELESS',
    TXT: lang.t('enums.netType.WIRELESS')
  }
}

export const TERMINAL_PALTFORM = {
  IDV: {
    CODE: 'IDV',
    TXT: lang.t('enums.terminalPlatform.IDV')
  },
  VDI: {
    CODE: 'VDI',
    TXT: lang.t('enums.terminalPlatform.VDI')
  },
  VOI: {
    CODE: 'VOI',
    TXT: lang.t('enums.terminalPlatform.VOI')
  }
}

export const TERMINAL_MODE = {
  PERSONAL: {
    CODE: 'PERSONAL',
    TXT: lang.t('enums.terminalMode.PERSONAL')
  },
  MULTI_USER: {
    CODE: 'MULTI_USER',
    TXT: lang.t('enums.terminalMode.MULTI_USER')
  },
  PUBLIC: {
    CODE: 'PUBLIC',
    TXT: lang.t('enums.terminalMode.PUBLIC')
  }
}

export const DESK_PATTERN = {
  PERSONAL: {
    CODE: 'PERSONAL',
    TXT: lang.t('enums.deskPattern.PERSONAL')
  },
  RECOVERABLE: {
    CODE: 'RECOVERABLE',
    TXT: lang.t('enums.deskPattern.RECOVERABLE')
  }
}
